import type { ComponentProps } from "react"

export default function PropertyLogistics(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M16 5.3335H26.6667C27.374 5.3335 28.0522 5.61445 28.5523 6.11454C29.0524 6.61464 29.3334 7.29292 29.3334 8.00016V22.6668C29.3334 23.0205 29.1929 23.3596 28.9429 23.6096C28.6928 23.8597 28.3537 24.0002 28 24.0002H26.6667C26.6667 22.9393 26.2453 21.9219 25.4951 21.1717C24.745 20.4216 23.7276 20.0002 22.6667 20.0002C21.6058 20.0002 20.5884 20.4216 19.8383 21.1717C19.0881 21.9219 18.6667 22.9393 18.6667 24.0002H14.6667C14.6655 23.4407 14.5462 22.8878 14.3164 22.3777C14.0866 21.8676 13.7516 21.4118 13.3334 21.0402V8.00016C13.3334 7.29292 13.6143 6.61464 14.1144 6.11454C14.6145 5.61445 15.2928 5.3335 16 5.3335Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20.0002C11.992 20.0784 11.9764 20.1557 11.9533 20.2308C11.3528 20.016 10.7092 19.9495 10.0774 20.0372C9.44569 20.1249 8.84451 20.364 8.32519 20.7343C7.80587 21.1046 7.38381 21.595 7.09501 22.1636C6.80621 22.7323 6.65923 23.3624 6.66663 24.0002H3.99996C3.64634 24.0002 3.3072 23.8597 3.05715 23.6096C2.8071 23.3596 2.66663 23.0205 2.66663 22.6668V14.6668C2.66663 13.2523 3.22853 11.8958 4.22872 10.8956C5.22892 9.8954 6.58547 9.3335 7.99996 9.3335H10.6666C11.0202 9.3335 11.3594 9.47397 11.6094 9.72402C11.8595 9.97407 12 10.3132 12 10.6668V20.0002ZM5.33329 16.0002H9.33329V13.3335H5.33329V16.0002Z"
        fill={fill}
      />
      <path
        d="M20.781 25.8858C20.281 25.3857 20 24.7074 20 24.0002C20 23.2929 20.281 22.6146 20.781 22.1145C21.2811 21.6144 21.9594 21.3335 22.6667 21.3335C23.3739 21.3335 24.0522 21.6144 24.5523 22.1145C25.0524 22.6146 25.3333 23.2929 25.3333 24.0002C25.3333 24.7074 25.0524 25.3857 24.5523 25.8858C24.0522 26.3859 23.3739 26.6668 22.6667 26.6668C21.9594 26.6668 21.2811 26.3859 20.781 25.8858Z"
        fill={fill}
      />
      <path
        d="M8 24.0002C8 24.7074 8.28095 25.3857 8.78105 25.8858C9.28115 26.3859 9.95942 26.6668 10.6667 26.6668C11.3739 26.6668 12.0522 26.3859 12.5523 25.8858C13.0524 25.3857 13.3333 24.7074 13.3333 24.0002C13.3333 23.2929 13.0524 22.6146 12.5523 22.1145C12.0522 21.6144 11.3739 21.3335 10.6667 21.3335C9.95942 21.3335 9.28115 21.6144 8.78105 22.1145C8.28095 22.6146 8 23.2929 8 24.0002Z"
        fill={fill}
      />
    </svg>
  )
}
